 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import OEBPSCOVER from '@/components/OEBPS/cover'
 import OEBPSHALFTITLE from '@/components/OEBPS/halftitle'
 import OEBPSHALF from '@/components/OEBPS/half'
 import LOVE_1 from '@/components/love_1'
 import OEBPSTITLE from '@/components/OEBPS/title'
 import OEBPSMINI_TOC from '@/components/OEBPS/mini_toc'
 import OEBPSCPN from '@/components/OEBPS/cpn'
 import OEBPSOTHER from '@/components/OEBPS/other'
 import OEBPSCH01 from '@/components/OEBPS/ch01'
 import OEBPSCH02 from '@/components/OEBPS/ch02'
 import OEBPSCH03 from '@/components/OEBPS/ch03'
 import OEBPSCH04 from '@/components/OEBPS/ch04'
 import OEBPSCH05 from '@/components/OEBPS/ch05'
 import OEBPSCH06 from '@/components/OEBPS/ch06'
 import OEBPSCH07 from '@/components/OEBPS/ch07'
 import OEBPSCH08 from '@/components/OEBPS/ch08'
 import OEBPSCH09 from '@/components/OEBPS/ch09'
 import LOVE_2 from '@/components/love_2'
 import OEBPSAFTER from '@/components/OEBPS/after'
 import OEBPSNOTES from '@/components/OEBPS/notes'
 import OEBPSINDEX from '@/components/OEBPS/index'
 import OEBPSBACKAD from '@/components/OEBPS/back-ad'
 import OEBPSAUTHOR from '@/components/OEBPS/author'
 import OEBPSBACKMATTER from '@/components/OEBPS/backmatter'
 import OEBPSBACKCOVER from '@/components/OEBPS/backcover'
 import OEBPSNEWSLETTER from '@/components/OEBPS/newsletter'
 import OEBPSCONTENTS from '@/components/OEBPS/contents'
 import OEBPSCOPYRIGHT from '@/components/OEBPS/copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/OEBPS/cover",
 			"name" : "OEBPS/cover",
 			"component" : OEBPSCOVER
 		},
 		{
 			"path" : "/OEBPS/halftitle",
 			"name" : "OEBPS/halftitle",
 			"component" : OEBPSHALFTITLE
 		},
 		{
 			"path" : "/OEBPS/half",
 			"name" : "OEBPS/half",
 			"component" : OEBPSHALF
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/OEBPS/title",
 			"name" : "OEBPS/title",
 			"component" : OEBPSTITLE
 		},
 		{
 			"path" : "/OEBPS/mini_toc",
 			"name" : "OEBPS/mini_toc",
 			"component" : OEBPSMINI_TOC
 		},
 		{
 			"path" : "/OEBPS/cpn",
 			"name" : "OEBPS/cpn",
 			"component" : OEBPSCPN
 		},
 		{
 			"path" : "/OEBPS/other",
 			"name" : "OEBPS/other",
 			"component" : OEBPSOTHER
 		},
 		{
 			"path" : "/OEBPS/ch01",
 			"name" : "OEBPS/ch01",
 			"component" : OEBPSCH01
 		},
 		{
 			"path" : "/OEBPS/ch02",
 			"name" : "OEBPS/ch02",
 			"component" : OEBPSCH02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js